<div class="p-6 w-full">
  <!-- Header -->
  <div class="header-section">
    <nav class="inter flex items-center space-x-2 text-sm text-gray-700 mb-4">
      <span class="material-symbols-outlined" style="font-size: 18px;">home</span>
      <span class="text-[14px] font-medium color-[#374151] cursor-pointer" (click)="navigateToMenu()">Home</span>
      <span class="material-symbols-outlined">arrow_forward_ios</span>
      <span class="text-[14px] font-medium color-[#374151]">Configuración de usuarios</span>
    </nav>
    <h1 class="text-[28px] font-medium text-black">Configuración de usuarios</h1>
  </div>

  <!-- Filtros y Acciones -->
  <div class="flex flex-col md:flex-row md:items-center md:justify-between flex-wrap gap-4 pb-2">
    <div class="flex flex-col md:flex-row flex-wrap gap-3 w-full md:w-auto">
      <app-custom-select
        [options]="sistemasOptions"
        placeholder="Todos los sistemas"
        backgroundColor="#ffffff"
        textColor="#374151"
        arrowColor="#6b7280"
        borderColor="#e1e5e9"
        [showIcon]="false"
        [(ngModel)]="selectedSystem"
        (selectionChange)="onSystemChange($event)">
      </app-custom-select>

      <app-custom-select
        [options]="perfilesOptions"
        placeholder="Todos los perfiles"
        backgroundColor="#ffffff"
        textColor="#374151"
        arrowColor="#6b7280"
        borderColor="#e1e5e9"
        [showIcon]="false"
        [(ngModel)]="selectedPerfil"
        (selectionChange)="onPerfilChange($event)">
      </app-custom-select>

      <div class="w-full md:w-60">
        <app-custom-search
          placeholder="Buscar"
          backgroundColor="#ffffff"
          textColor="#374151"
          iconColor="#9ca3af"
          borderColor="#e1e5e9"
          focusBorderColor="#3b82f6"
          [showClearButton]="false"
          [(ngModel)]="searchText"
          (keyup)="onSearchKeyup($event)">
        </app-custom-search>
      </div>
    </div>

    <div class="flex flex-col md:flex-row flex-wrap gap-3 w-full md:w-auto md:justify-end">
      <app-custom-button
        text="Exportar excel"
        backgroundColor="#5CA42F"
        borderColor="#5CA42F"
        size="md"
        icon='<span class="material-symbols-outlined">file_save</span>'
        iconPosition="left"
        hoverBackgroundColor="#487F25"
        hoverTextColor="#ffffff"
        (click)="exportarExcel()">
      </app-custom-button>

      <app-custom-button
        text="Agregar nuevo usuario"
        backgroundColor="#005FFF"
        borderColor="#005FFF"
        size="md"
        icon='<span class="material-symbols-outlined">add</span>'
        iconPosition="left"
        hoverBackgroundColor="#0549BD"
        hoverTextColor="#ffffff"
        (click)="onAddUser()">
      </app-custom-button>
    </div>
  </div>

  <!-- Tabla -->
    <mat-card>
      <mat-card-content class="!p-0 bg-white">
        <div class="table-container">
          <table mat-table [dataSource]="dataSource" matSort>

            <!-- Usuario -->
            <ng-container matColumnDef="username">
              <th mat-header-cell *matHeaderCellDef class="text-white"  mat-sort-header>USUARIO</th>
              <td mat-cell *matCellDef="let element" [title]="element.username">{{element.username}}</td>
            </ng-container>

            <!-- Nombre -->
            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>NOMBRE</th>
              <td mat-cell *matCellDef="let element" [title]="element.nombre + ' ' + element.apellido">{{element.nombre}} {{element.apellido}}</td>            </ng-container>

            <!-- Correo -->
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>CORREO</th>
              <td mat-cell *matCellDef="let element" [title]="element.email">{{element.email}}</td>
            </ng-container>

            <!-- Perfil -->
            <ng-container matColumnDef="perfil">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>PERFIL</th>
              <td mat-cell *matCellDef="let usuario" class="text-center py-3 table-td">
                {{usuario.perfil.length>0 ? usuario.perfil[0].nombre : ''}}
                @if (usuario.perfil.length > 1) {

                  <app-custom-tooltip
                    [text]="getPerfilesLabel(usuario)"
                    position="above">
                    <label class="cursor-pointer">
                      (+{{ usuario.perfil.length < 3 ? 'otro' : 'otros'}})
                    </label>
                  </app-custom-tooltip>
                }

              </td>
            </ng-container>

            <!-- Sistema -->
            <ng-container matColumnDef="sistema">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> SISTEMA </th>
              <td mat-cell *matCellDef="let usuario" class="text-center py-3 table-td">

                {{usuario.perfil.length > 0 ? usuario.perfil[0].sistemas.length > 0 ? usuario.perfil[0].sistemas[0].nombre : '' : ''}}

                @if (getCantSis(usuario.perfil) > 1) {
                  <app-custom-tooltip
                    [text]="getSistemasLabel(usuario.perfil)"
                    position="above">
                    <label class="cursor-pointer">
                      (+{{ getCantSis(usuario.perfil) < 3 ? 'otro' : 'otros' }})
                    </label>
                  </app-custom-tooltip>
                }
              </td>
            </ng-container>


            <!-- Vigente -->
            <ng-container matColumnDef="vigente" >
              <th mat-header-cell *matHeaderCellDef mat-sort-header>VIGENTE</th>
              <td mat-cell *matCellDef="let element">
                <mat-slide-toggle
                  [checked]="element.vigente"
                  [hideIcon]="true"
                  (change)="onEditVigente(element)"
                  class="!scale-[0.8]">
                </mat-slide-toggle>
              </td>
            </ng-container>

            <!-- Acción -->
            <ng-container matColumnDef="accion">
              <th mat-header-cell *matHeaderCellDef>ACCIÓN</th>
              <td mat-cell *matCellDef="let usuario">
                <div class="flex gap-1 items-center justify-left">
                  <button mat-icon-button (click)="onOpenModalEditUser(usuario)">
                    <span class="material-symbols-outlined" style="font-size: 18px; font-variation-settings: 'opsz' 18;color: #6B7280;">
                      edit_square
                    </span>
                  </button>
                  @if (verificarEliminar(usuario)) {
                    <button
                      mat-icon-button
                      (click)="onDeleteUser(usuario)">
                        <span class="material-symbols-outlined" style="font-size: 18px; font-variation-settings: 'opsz' 18;color: #6B7280;">
                          delete
                        </span>
                    </button>
                  }
                </div>
              </td>
            </ng-container>

            <!-- Header y Body -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="hover:bg-gray-50 transition-colors duration-150"></tr>
          </table>
        </div>

        <!-- Paginador -->
        <mat-paginator [pageSizeOptions]="[10, 25, 100]" [showFirstLastButtons]="false"></mat-paginator>
      </mat-card-content>
    </mat-card>


  <!-- Modal Eliminar usuario -->
  <app-delete-confirmation-modal
    [isOpen]="showDeleteUserModal"
    [title]="titleDeleteModal"
    [message]="'¿Estás seguro que desea eliminar el usuario?'"
    [loading]="deletingUser"
    (confirm)="confirmDeleteUser()"
    (cancel)="onCloseDeleteModal()"
    (close)="onCloseDeleteModal()">
  </app-delete-confirmation-modal>

</div>
